module.exports = __webpack_public_path__ + "static/media/binance.c8fe6699.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/exchanges/binance.svg
// module id = 96
// module chunks = 0